'use strict';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

Shopify.theme.jsAjaxCart = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    );

    if (
      isScreenSizeLarge() ||
      this.cart_action == 'drawer'
    ) {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {
      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');
      $(document).on(
        'click',
        '[data-ajax-cart-trigger]',
        function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();
          return false;
        }
      );
    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
      return false;
    });
    $(document).on(
      'click',
      '[data-ajax-cart-delete]',
      function (e) {
        e.preventDefault();
        var itemKey = $(this).data('cart-item-key');
        Shopify.theme.jsAjaxCart.removeFromCart(itemKey);

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.removeFromCart(itemKey);
        }
        if (
          typeof BOLD === 'object' &&
          BOLD.common &&
          BOLD.common.eventEmitter &&
          typeof BOLD.common.eventEmitter.emit ===
            'function'
        ) {
          $.getJSON('/cart.js', function (data) {
            BOLD.common.cartDoctor.fix(data);
          });
        }

        return false;
      }
    );
    $(document).on(
      'click',
      '[data-ajax-cart-close]',
      function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();
        return false;
      }
    );
    $(window).on('load', function () {
      // GIP-vanity-update
      $('.gip-secondary-cart input.quantity-input').each(
        function () {
          $(this)
            .removeClass('gip-cart-line-item-qty')
            .addClass('gip-secondary-cart-line-item-qty');
        }
      );

      $('.mobile-header')
        .find("[class*='gip-secondary']")
        .each(function () {
          $(this).attr(
            'class',
            this.className.replace(
              /gip-secondary/gi,
              'gip-extra'
            )
          );
        });
    });
  },
  showMiniCartOnHover: function showMiniCartOnHover() {
    var $el = $('[data-ajax-cart-trigger]');
    $el.hover(
      function () {
        $el.addClass('show-mini-cart');
      },
      function () {
        $el.removeClass('show-mini-cart');
      }
    );

    setTimeout(function () {
      fixHooks();
      if (
        window.BOLD &&
        BOLD.recurring_orders &&
        BOLD.recurring_orders.app
      ) {
        $.getJSON('/cart.js', function (data) {
          BOLD.common.cartDoctor.fix(data);
          BOLD.recurring_orders.app.renderLineItems(
            BOLD.common.cartDoctor.cart
          );
        });
      }
    }, 500);
  },
  hideMiniCart: function hideMiniCart() {
    if (this.cart_action != 'mini_cart') return false;
    var $el = $('[data-ajax-cart-close]').parents(
      '[data-ajax-cart-trigger]'
    );
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function toggleMiniCart() {
    var $el = $('.mobile-header [data-ajax-cart-trigger]'); // Removes url to the cart page so user is not redirected

    $el.attr('href', '#');
    $el.off('click').on('click', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      } // Loads content into ajaxCart container for mobile header

      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile(); // If user clicks outside the element, toggle the mini cart

      $el.toggleClass('show-mini-cart'); // Calculate height of mini cart

      var announcementHeight = 0;
      var mobileHeaderHeight = parseInt(
        $('.mobile-header').height()
      );

      if (
        typeof Shopify.theme.jsAnnouncementBar !==
          'undefined' &&
        Shopify.theme.jsAnnouncementBar.enable_sticky
      ) {
        announcementHeight =
          Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      $('.mobile-header .theme-ajax-cart').css({
        height: 'calc(100vh - '.concat(
          mobileHeaderHeight + announcementHeight,
          'px)'
        ),
      });
    });
  },
  showDrawer: function showDrawer() {
    console.log('show drawer');
    setTimeout(function () {
      _rs_ajax.updateCart();
    }, 2000);
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');

    if (
      window.BOLD &&
      BOLD.common &&
      BOLD.common.eventEmitter &&
      typeof BOLD.common.eventEmitter.emit === 'function'
    ) {
      BOLD.recurring_orders.app.renderLineItems();
    }

    if (
      $(
        '.ajax-cart__list span[data-product-id="6593234534472"]'
      ).length > 0
    ) {
      $('.mystery-strap-cart-ajax').hide();
    }
  },
  hideDrawer: function hideDrawer() {
    // console.log('hide drawer');
    setTimeout(function () {
      _rs_ajax.updateCart();
    }, 2000);
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function removeFromCart(
    itemKey,
    callback
  ) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + itemKey,
      dataType: 'json',
      success: function success(cart) {
        setTimeout(function () {
          _rs_ajax.updateCart();
        }, 2000);
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function error(XMLHttpRequest, textStatus) {
        var response = eval(
          '(' + XMLHttpRequest.responseText + ')'
        );
        response = response.description;
      },
    });
  },
  initializeAjaxCart: function initializeAjaxCart() {
    Shopify.theme.asyncView
      .load(
        '/cart', // template name
        'ajax' // view name (suffix)
      )
      .done(function (_ref) {
        var html = _ref.html,
          options = _ref.options;
        $('[data-ajax-cart-content]').html(html.content);

        if (
          Shopify.theme_settings.show_multiple_currencies
        ) {
          convertCurrencies();
        }

        $('.mystery-strap-size__option').each(function () {
          $(this).on('click', function () {
            var variantId = $(this).attr('data-variant-id');
            $('.mystery-strap-size__option').removeClass(
              'active'
            );
            $(
              '.mystery-strap-size__option[data-variant-id=' +
                variantId +
                ']'
            ).addClass('active');
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              dataType: 'json',
              data: {
                updates: {
                  36542445813832: 0,
                  36542445846600: 0,
                },
              },
              cache: false,
              success: function success() {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  cache: false,
                  data: {
                    quantity: 1,
                    id: variantId,
                  },
                  dataType: 'json',
                  success: function (data) {
                    Shopify.theme.jsAjaxCart.updateView();
                  },
                });
              },
            });
          });
        });
      })
      .fail(function () {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile:
    function initializeAjaxCartOnMobile() {
      this.toggleMiniCart();
      Shopify.theme.asyncView
        .load(
          '/cart', // template name
          'ajax' // view name (suffix)
        )
        .done(function (_ref2) {
          var html = _ref2.html,
            options = _ref2.options;
          $('.mobile-header [data-ajax-cart-content]').html(
            html.content
          );

          if (
            Shopify.theme_settings.show_multiple_currencies
          ) {
            convertCurrencies();
          }
        })
        .fail(function () {
          // some error handling
        });
    },
  addToCart: function addToCart($addToCartForm) {
    var $addToCartBtn = $addToCartForm.find(
      '.button--add-to-cart'
    );
    // console.log($addToCartForm);
    // console.log($addToCartForm.serialize());
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $addToCartForm.serialize(),
      beforeSend: function beforeSend() {
        $addToCartBtn
          .attr('disabled', 'disabled')
          .addClass('disabled');
        $addToCartBtn
          .find('span')
          .removeClass('fadeInDown')
          .addClass('animated zoomOut');
      },
      success: function success(product) {
        if (
          typeof window.BOLD !== 'undefined' &&
          typeof window.BOLD.common !== 'undefined' &&
          typeof window.BOLD.common.cartDoctor !==
            'undefined'
        ) {
          // NOTE: "item" should be the variable containing the item json data from the cart/add.js response
          product =
            window.BOLD.common.cartDoctor.fixItem(product);
        }

        // add bundle extra products
        var bundle = $('.bundle-input:checked')
          .map(function () {
            return $(this).val();
          })
          .get();

        if (bundle.length > 0) {
          Shopify.queue = [];

          Shopify.moveAlong = function () {
            // If we still have requests in the queue, let's process the next one.
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: {
                  quantity: 1,
                  id: request.variantId,
                },
                success: function (res) {
                  Shopify.moveAlong();
                },
                error: function () {
                  if (Shopify.queue.length) {
                    Shopify.moveAlong();
                  }
                },
              });
            } else {
              $.ajax({
                url: '/cart.js',
                dataType: 'json',
                cache: false,
                success: function (cart) {
                  var $el = $('[data-ajax-cart-trigger]');
                  $addToCartBtn
                    .find('.checkmark')
                    .addClass('checkmark-active');

                  function addedToCart() {
                    if (!isScreenSizeLarge()) {
                      $el = $(
                        '.mobile-header [data-ajax-cart-trigger]'
                      );
                      Shopify.theme.scrollToTop($el);
                    } else {
                      $el = $('[data-ajax-cart-trigger]');
                    }

                    $el.addClass('show-mini-cart');
                    $addToCartBtn
                      .find('span')
                      .removeClass('fadeInDown');
                  }

                  window.setTimeout(function () {
                    $addToCartBtn
                      .removeAttr('disabled')
                      .removeClass('disabled');
                    $addToCartBtn
                      .find('.checkmark')
                      .removeClass('checkmark-active');
                    $addToCartBtn
                      .find('span')
                      .removeClass('zoomOut')
                      .addClass('fadeInDown');
                    $addToCartBtn.on(
                      'webkitAnimationEnd oanimationend msAnimationEnd animationend',
                      addedToCart
                    );
                  }, 1000);
                  Shopify.theme.jsAjaxCart.showDrawer();
                  Shopify.theme.jsAjaxCart.updateView();
                },
              });
            }
          };
          $.each(bundle, function (i, product) {
            Shopify.queue.push({
              variantId: product,
              quantity: 1,
            });
          });

          Shopify.moveAlong();
        } else {
          var $el = $('[data-ajax-cart-trigger]');
          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {
            if (!isScreenSizeLarge()) {
              $el = $(
                '.mobile-header [data-ajax-cart-trigger]'
              );
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');
            $addToCartBtn
              .find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');
            $addToCartBtn
              .find('.checkmark')
              .removeClass('checkmark-active');
            $addToCartBtn
              .find('span')
              .removeClass('zoomOut')
              .addClass('fadeInDown');
            $addToCartBtn.on(
              'webkitAnimationEnd oanimationend msAnimationEnd animationend',
              addedToCart
            );
          }, 1000);
          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();
        }

        if (Shopify.theme.jsCart) {
          var _$$ajax;

          $.ajax(
            ((_$$ajax = {
              dataType: 'json',
              async: false,
              cache: false,
            }),
            _defineProperty(_$$ajax, 'dataType', 'html'),
            _defineProperty(_$$ajax, 'url', '/cart'),
            _defineProperty(
              _$$ajax,
              'success',
              function success(html) {
                var cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);
              }
            ),
            _$$ajax)
          );
        }
        setTimeout(function () {
          _rs_ajax.updateCart();

          if (
            BOLD &&
            BOLD.recurring_orders &&
            BOLD.recurring_orders.app &&
            BOLD.recurring_orders.app.ee &&
            typeof BOLD.recurring_orders.app.ee.emit ===
              'function'
          ) {
            var mobileCart = document.querySelector(
              '#mobile-header'
            );
            var hooks = mobileCart.querySelectorAll(
              '.bold_cart_item_total'
            );
            hooks.forEach(function (hook) {
              hook.classList =
                'Bold-theme-hook-DO-NOT-DELETE bold_cart_item_total_2';
              console.log('hooks set');
            });

            $.getJSON('/cart.js', function (data) {
              BOLD.common.cartDoctor.fix(data);
              BOLD.recurring_orders.app.renderLineItems(
                BOLD.common.cartDoctor.cart
              );
            });
          }
        }, 2000);
      },
      error: function error(XMLHttpRequest) {
        var response = eval(
          '(' + XMLHttpRequest.responseText + ')'
        );
        response = response.description;
        var cartWarning =
          '<p class="cart-warning__message animated bounceIn">'.concat(
            response.replace('All 1 ', 'All '),
            '</p>'
          );
        $('.warning').remove();
        $addToCartForm
          .find('.cart-warning')
          .html(cartWarning);
        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');
        $addToCartBtn
          .find('span')
          .text(Shopify.translation.addToCart)
          .removeClass('zoomOut')
          .addClass('zoomIn');
      },
    });
  },
  updateView: function updateView() {
    Shopify.theme.asyncView
      .load(
        '/cart', // template name
        'ajax' // view name (suffix)
      )
      .done(function (_ref3) {
        var html = _ref3.html,
          options = _ref3.options;

        if (options.item_count > 0) {
          var itemList = $(html.content).find(
            '.ajax-cart__list'
          );
          var savings = $(html.content).find(
            '.ajax-cart__savings'
          );
          var subtotal = $(html.content).find(
            '.ajax-cart__subtotal'
          );
          $('.ajax-cart__list').replaceWith(itemList);
          $('.ajax-cart__savings').replaceWith(savings);
          $('.ajax-cart__subtotal').replaceWith(subtotal);
          $('.ajax-cart__empty-cart-message').addClass(
            'is-hidden'
          );
          $('.ajax-cart__form').removeClass('is-hidden');
          $('[data-ajax-cart-trigger]').addClass(
            'has-cart-count'
          );

          $.getJSON('/cart.js', function (data) {
            BOLD.common.cartDoctor.fix(data);

            console.log(BOLD.common.cartDoctor.cart);

            var itemCount =
              BOLD.common.cartDoctor.cart.items.reduce(
                function (total, curr) {
                  return curr.product_type != 'SCRATCHER'
                    ? total + curr.quantity
                    : total;
                },
                0
              );
            $('[data-bind="itemCount"]').text(
              // options.item_count
              itemCount
            );

            var mysteryStrapCount =
              BOLD.common.cartDoctor.cart.items.reduce(
                function (total, curr) {
                  var totalCount = total;
                  switch (curr.variant_id.toString()) {
                    case '36542445846600':
                    case '36542445813832':
                      console.log(totalCount + curr.price);
                      return totalCount + curr.price;
                  }
                  return total;
                },
                0
              );

            var mystery_strap_target =
              5000 +
              mysteryStrapCount -
              BOLD.common.cartDoctor.cart.total_price;
            if (mystery_strap_target < 0) {
              mystery_strap_target = 0;
            }

            $('.ajax-cart-free-mystery-amount .money').html(
              Shopify.formatMoney(mystery_strap_target)
            );

            $(
              '.mystery-strap-cart-ajax__center .qualifies'
            ).hide();
            $('.mystery-strap-cart-ajax__right').hide();
            $(
              '.mystery-strap-cart-ajax__center .almost-qualifies'
            ).hide();

            var hideMysteryStrap =
              BOLD.common.cartDoctor.cart.items.reduce(
                function (state, curr) {
                  switch (curr.product_id.toString()) {
                    case '6593234534472':
                      return true;
                  }
                  return state;
                },
                false
              );

            if (hideMysteryStrap) {
              $('.mystery-strap-cart-ajax').hide();
            }

            if (mystery_strap_target == 0) {
              $(
                '.mystery-strap-cart-ajax__center .qualifies'
              ).show();
              $('.mystery-strap-cart-ajax__right').show();
            } else {
              $(
                '.mystery-strap-cart-ajax__center .almost-qualifies'
              ).show();
            }
          });

          var subtotal_cents = parseInt(
            $('.ajax-cart__subtotal .money > .money')
              .html()
              .replace(/[^0-9]/g, '')
          );
          var free_shipping_target = 3500 - subtotal_cents;

          if (free_shipping_target < 0) {
            free_shipping_target = 0;
          }

          $('.ajax-cart-free-shipping-amount .money').html(
            Shopify.formatMoney(free_shipping_target)
          );
        } else {
          $('.ajax-cart__empty-cart-message').removeClass(
            'is-hidden'
          );
          $('.ajax-cart__form').addClass('is-hidden');
          $('[data-ajax-cart-trigger]').removeClass(
            'has-cart-count'
          );
          $('[data-bind="itemCount"]').text('0');
        }
        // GIP-vanity-update
        $('.gip-secondary-cart input.quantity-input').each(
          function () {
            $(this)
              .removeClass('gip-cart-line-item-qty')
              .addClass('gip-secondary-cart-line-item-qty');
          }
        );
        $('.mobile-header')
          .find("[class*='gip-secondary']")
          .each(function () {
            $(this).attr(
              'class',
              this.className.replace(
                /gip-secondary/gi,
                'gip-extra'
              )
            );
          });

        if (
          Shopify.theme_settings.show_multiple_currencies
        ) {
          convertCurrencies();
        }
      })
      .fail(function () {
        // some error handling
      });
  },
  unload: function unload($section) {
    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  },
};
